export default __webpack_public_path__ + "static/media/gp-black.cfe82d27.svg";